import { BaseAPIRequestFactory, RequiredError } from './baseapi';
import type { Configuration } from '../configuration';
import { RequestContext, HttpMethod, ResponseContext, HttpInfo } from '../http/http';
import { ObjectSerializer } from '../models/ObjectSerializer';
import { ApiException } from './exception';
import { isCodeInRange } from '../util';
import type {SecurityAuthentication} from '../auth/auth';
import type {HttpFile} from '../http/http';


import { ObjectStoreExclusionRule } from '../models/ObjectStoreExclusionRule';

/**
 * no description
 */
export class UpdateObjectStoreExclusionRuleApiRequestFactory extends BaseAPIRequestFactory {

  /**
   * Update a object store exclusion rule
   * @param id ID of the rule to update
   * @param projectId The project ID
   * @param objectStoreExclusionRule The request body for updating a object store exclusion rule
   */
  public async updateObjectStoreExclusionRule(id: string, projectId: string, objectStoreExclusionRule: ObjectStoreExclusionRule, _options?: Configuration): Promise<RequestContext> {
    let _config;
    if (!_options) {
      _config = this.configuration;
    } else {
      _config = Object.assign({}, _options, this.configuration);
    }
    


    // verify required parameter 'id' is not null or undefined
    if (id === null || id === undefined) {
      throw new RequiredError("UpdateObjectStoreExclusionRuleApi", "updateObjectStoreExclusionRule", "id");
    }


    // verify required parameter 'projectId' is not null or undefined
    if (projectId === null || projectId === undefined) {
      throw new RequiredError("UpdateObjectStoreExclusionRuleApi", "updateObjectStoreExclusionRule", "projectId");
    }


    // verify required parameter 'objectStoreExclusionRule' is not null or undefined
    if (objectStoreExclusionRule === null || objectStoreExclusionRule === undefined) {
      throw new RequiredError("UpdateObjectStoreExclusionRuleApi", "updateObjectStoreExclusionRule", "objectStoreExclusionRule");
    }


    // Path Params
    const localVarPath = '/projects/{projectId}/object-store-exclusion-rules/{id}'
      .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
      .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));

    let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
    // Make Request Context
    const requestContext = _config.baseServer!.makeRequestContext(localVarPath, HttpMethod.PUT, signal);
    requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")


    // Body Params
    const contentType = "application/json"
    requestContext.setHeaderParam("Content-Type", contentType);
    const serializedBody = JSON.stringify(ObjectSerializer.serialize(objectStoreExclusionRule, "ObjectStoreExclusionRule", ""));
    requestContext.setBody(serializedBody);

    let authMethod: SecurityAuthentication | undefined;
    // Apply auth methods
    authMethod = _config.authMethods!["ApiKeyAuth"]
    if (authMethod?.applySecurityAuthentication) {
      await authMethod?.applySecurityAuthentication(requestContext);
    }

    return requestContext;
  }

}

export class UpdateObjectStoreExclusionRuleApiResponseProcessor {

  /**
   * Unwraps the actual response sent by the server from the response context and deserializes the response content
   * to the expected objects
   *
   * @params response Response returned by the server for a request to updateObjectStoreExclusionRule
   * @throws ApiException if the response code was not in [200, 299]
   */
   public async updateObjectStoreExclusionRuleWithHttpInfo(response: ResponseContext): Promise<HttpInfo<ObjectStoreExclusionRule >> {
    if (isCodeInRange("200", response.httpStatusCode)) {
      const body: ObjectStoreExclusionRule = ObjectSerializer.deserialize(
        await response.body.json(),
        "ObjectStoreExclusionRule", ""
      ) as ObjectStoreExclusionRule;
      return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    if (isCodeInRange("404", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Rule not found", undefined, response.headers, response);
    }
    if (isCodeInRange("1XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Informational", undefined, response.headers, response);
    }
    if (isCodeInRange("3XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Redirect", undefined, response.headers, response);
    }
    if (isCodeInRange("4XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Client Error", body, response.headers, response);
    }
    if (isCodeInRange("5XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
    }

    // Work around for missing responses in specification, e.g. for petstore.yaml
    if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
      throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
    }
    const body: ObjectStoreExclusionRule = await response.body.json() as ObjectStoreExclusionRule;
    return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
  }

}
